import { useCallback, useEffect, useState } from 'react';
import { useMap, useNavermaps } from 'react-naver-maps';
import { opinetApi as api } from '@/shared/api';
import { FUEL_TYPE_OPTION, MIN_ZOOM_LEVEL } from '@/shared/consts';
import { useDebounce } from '@/shared/lib';

const useStationsAround = (
	fuelType: (typeof FUEL_TYPE_OPTION)[number]['value'],
) => {
	const map = useMap();
	const navermaps = useNavermaps();
	const [stationsAround, setStationsAround] = useState<
		Awaited<ReturnType<typeof api.getStationsAround>>['RESULT']['OIL']
	>([]);

	const fetchStationsAround = useCallback(async () => {
		if (map.getZoom() < MIN_ZOOM_LEVEL || !navermaps.TransCoord) return;

		const center = map.getCenter();
		const katec = navermaps.TransCoord.fromLatLngToTM128(center);
		const data = await api.getStationsAround(katec.y, katec.x, fuelType);
		setStationsAround(data.RESULT.OIL);
	}, [map, navermaps, fuelType]);

	const debouncedFetchStationsAround = useDebounce(fetchStationsAround, 300);

	useEffect(() => {
		fetchStationsAround();
	}, [fetchStationsAround]);

	useEffect(() => {
		const listener = map.addListener(
			'center_changed',
			debouncedFetchStationsAround,
		);
		return () => map.removeListener(listener);
	}, [map, debouncedFetchStationsAround]);

	return stationsAround;
};

export default useStationsAround;
